import pluginRegistry from '../plugin/PluginProvider';

export function isDieselSaga(plugin) {
    return (plugin && plugin.dieselSagaPlugin) || false;
}

export default function dieselSaga(name, target, bootstrap) {
    target.dieselSagaPlugin = true;
    target.bootstrap = bootstrap;
    target.reducerName = name;
    pluginRegistry.providePlugin(target);
}
